import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=310f865d"
import script from "./InputLabel.vue?vue&type=script&lang=ts"
export * from "./InputLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports